import { getRuErrorsTrnaslations } from "../constants/errors";

export default {
    appError: 'Ошибка - не удалось запустить приложение',
    appReload: 'Перезагрузить',
    nomatch: 'Страница не найдена',
    title: 'Основание на обработку персональных данных',
    titleKZ: 'Согласие на обработку персональных данных',
    fields: {
        lastName: 'Фамилия',
        firstName: 'Имя',
        middleName: 'Отчество',
        birthdate: 'Дата рождения',
        address: 'Адрес проживания',
        email: 'Адрес электронной почты',
        phone: 'Контактный телефон',
        cancelReason: 'Причина отказа'
    },
    sureQuestion: 'Вы уверены?',
    cancel: 'Отмена',
    radioYes: 'Да',
    radioNo: 'Нет',
    approveDate: 'Дата согласия',
    submit: 'Отправить',
    reject: 'Отказаться',
    error: 'Не удалось отправить ОПД',
    cancelledError: 'Не удалось отправить отказ ОПД',
    cancelledSuccess: 'Согласие на обработку персональных данных отклонено',
    success: 'Согласие на обработку персональных данных успешно отправлено!',
    languages: 'Язык/Language',
    countries: {
        label: 'Выберите страну, в которой вы обратились в компанию ANCOR',
        ru: 'Россия',
        kz: 'Казахстан',
        by: 'Беларусь',
        uz: 'Узбекистан'
    },
    errors: {
        ...getRuErrorsTrnaslations()
    }
}
